import React from "react";
import Grid from "../Grid";
import Card from "../Card";
import { Clock, AlertTriangle, Info, Syringe, TestTubeDiagonal } from "lucide-react";
import Spacing from "../Spacing";
import { useNavigate } from "react-router-dom";
import { can_visit, numberWithCommas } from "../../helpers";
import Skeleton from "react-loading-skeleton";

export default function OverViewSection({ dashboardOverviewDataCounts, labFUMisiingData, dashboardLabFULoader, dashboardGraphLoader }) {
  const navigate = useNavigate();

  const handleDispatchOverView = (type, path) => {
    navigate(`${path}?overviewtype=${type}`);
  };

  return (
    <div className="docpro_table_responsive dashboard" id="dashboard-overview">
      <Grid variant="docpro_grid docpro_grid_gap_10 docpro_grid_col_4 docpro_main_cards">
        {can_visit('dashboard_overview_lab_report_flu_missed')  && (
          <span
            className="docpro_card_1_link pointer"
            style={{ pointerEvents: `${dashboardLabFULoader ? "none" : "initial"}` }}
            onClick={() => handleDispatchOverView("fu_missing", "/lab-report-missed")}
          >
            <Card variant="docpro_card_md docpro_card_1">
              <div className="flex items-center justify-between docpro_grid_gap_10">
                <h3 className="docpro_fs_14 docpro_mb_0 docpro_crimson_color">
                  <TestTubeDiagonal width={20} height={20} /> Lab Report f/u Missed
                </h3>
                <button className="docpro_icon_btn overview" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
                  <Info width={16} height={16} />
                  <div className="docpro_tip">
                    <span>Lab report follow up missed</span>
                  </div>
                </button>
              </div>
              <Spacing lg="4" sm="4" />
              <div>
                {!dashboardLabFULoader ?
                  <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
                    {numberWithCommas(labFUMisiingData || 0)}
                  </p>
                :
                  <Skeleton width="7rem" height="2.3rem" borderRadius="8px"></Skeleton>
                }
              </div>
            </Card>
          </span>
        )}
        {can_visit('dashboard_overview_high_risk_patients')  && (
          <span
            className="docpro_card_1_link pointer"
            style={{ pointerEvents: `${dashboardLabFULoader ? "none" : "initial"}` }}
            onClick={() => handleDispatchOverView("High", "/high-risk-patients")}
          >
            <Card variant="docpro_card_md docpro_card_1">
              <div className="flex items-center justify-between docpro_grid_gap_10">
                <h3 className="docpro_fs_14 docpro_mb_0 docpro_red_color">
                  <AlertTriangle width={20} height={20} /> High-Risk Patients
                </h3>
                <button className="docpro_icon_btn overview" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
                  <Info width={16} height={16} />
                  <div className="docpro_tip">
                    <span>Patients who have <br /> three or more chronic conditions</span>
                  </div>
                </button>
              </div>
              <Spacing lg="4" sm="4" />
              <div>
                {!dashboardGraphLoader ?
                  <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
                    {numberWithCommas(dashboardOverviewDataCounts?.high_risk_count || 0)}
                  </p>
                :
                  <Skeleton width="8rem" height="2.3rem" borderRadius="8px"></Skeleton>
                }
              </div>
            </Card>
          </span>
        )}
        {can_visit('dashboard_overview_annual_wellness')  && (
          <span
            className="docpro_card_1_link pointer"
            style={{ pointerEvents: `${dashboardLabFULoader ? "none" : "initial"}` }}
            onClick={() => handleDispatchOverView(true, "/annual-wellness")}
          >
            <Card variant="docpro_card_md docpro_card_1">
              <div className="flex items-center justify-between docpro_grid_gap_10">
                <h3 className="docpro_fs_14 docpro_mb_0 docpro_indigo_color">
                  <Syringe width={20} height={20} /> Annual Wellness
                </h3>
                <button className="docpro_icon_btn overview" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
                  <Info width={16} height={16} />
                  <div className="docpro_tip">
                    <span>Patients who came this year <br /> but still have Annual Wellness Visit due</span>
                  </div>
                </button>
              </div>
              <Spacing lg="4" sm="4" />
              <div>
                {!dashboardGraphLoader ?
                  <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
                    {numberWithCommas(dashboardOverviewDataCounts?.preventative_due_count || 0)}
                  </p>
                :
                  <Skeleton width="7.5rem" height="2.3rem" borderRadius="8px"></Skeleton>
                }
              </div>
            </Card>
          </span>
        )}
        {can_visit('dashboard_overview_havent_visited')  && (
          <span
            className="docpro_card_1_link pointer"
            style={{ pointerEvents: `${dashboardLabFULoader ? "none" : "initial"}` }}
            onClick={() => handleDispatchOverView(365, "/haven-not-visited-in-one-year") }
          >
            <Card variant="docpro_card_md docpro_card_1">
              <div className="flex items-center justify-between docpro_grid_gap_10">
                <h3 className="docpro_fs_14 docpro_mb_0 docpro_teal_color">
                  <Clock width={20} height={20} /> Haven’t Visited This Year
                </h3>
                <button className="docpro_icon_btn last_btn_tip overview" style={{ width: 'auto', height: 'auto', borderRadius: '50%' }} >
                  <Info width={16} height={16} />
                  <div className="docpro_tip">
                    <span>Patients who came to your clinic <br /> in the past two years, <br /> but have not visited this year</span>
                  </div>
                </button>
              </div>
              <Spacing lg="4" sm="4" />
              <div>
                {!dashboardGraphLoader ?
                  <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
                    {numberWithCommas(dashboardOverviewDataCounts?.havent_visited || 0)}
                  </p>
                :
                  <Skeleton width="8.5rem" height="2.3rem" borderRadius="8px"></Skeleton>
                }
              </div>
            </Card>
          </span>
        )}
      </Grid>
    </div>
  );
}
